import * as React from 'react';
import Chip from '@mui/material/Chip';
import Tooltip from '@mui/material/Tooltip';

import { categorie } from './composition.ts';

// Couleurs par categorie : le corps reste neutre, les parties de modele
// sont colorees pour se distinguer d'un coup d'oeil dans la liste.
const COULEURS: Record<string, 'default' | 'primary' | 'info' | 'success' | 'secondary' | 'warning'> = {
  CORPS: 'default',
  SEANCE: 'primary',
  COMPETITION: 'warning',
  ECHAUFFEMENT: 'info',
  RECUPERATION: 'success',
  MODELE: 'secondary',
};

/** Categorie de seance (corps, echauffement, recuperation, modele). */
export default function CategorieChip({ code, parDefaut }: { code?: string | null; parDefaut?: string[] }) {
  const c = categorie(code);
  // parDefaut : usages (libelles) pour lesquels ce modele est le modele par defaut.
  const defaut = parDefaut && parDefaut.length > 0;
  return (
    <Tooltip title={c.description + (defaut ? ` — modèle par défaut : ${parDefaut.join(', ')}` : '')} arrow>
      <Chip
        size="small"
        color={COULEURS[c.code]}
        variant={defaut ? 'filled' : 'outlined'}
        label={defaut ? `${c.libelle} ★` : c.libelle}
      />
    </Tooltip>
  );
}
